import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TechsupportSelectedCompanyOptionService {
  private selectedOptionSource = new BehaviorSubject<any>(null);
  selectedOption$ = this.selectedOptionSource.asObservable();

  setSelectedOption(option: any) {
    this.selectedOptionSource.next(option);
  }

  getSelectedOption() {
    return this.selectedOptionSource.value;
  }
}
